import { render, staticRenderFns } from "./KeywordList.vue?vue&type=template&id=17de85b5"
import script from "./KeywordList.vue?vue&type=script&lang=js"
export * from "./KeywordList.vue?vue&type=script&lang=js"
import style0 from "./KeywordList.vue?vue&type=style&index=0&id=17de85b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports